import React, { useState, useRef, useEffect } from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import Input from "aldoo-ra/Input"
import Localization from "aldoo-ra/Localization"

export default function ShoppingCartFooter({ store }) {
  const texts = TextBundle({ id: "aldoo-store" })
  const { t } = Localization()
  const [showPromoInput, setShowPromoInput] = useState(false)
  const promoInputRef = useRef(null)

  const {
    setPromoCode,
    setPromoCodeError,
    promoCode,
    getCartTotalValue,
    beginCheckout,
    applyPromoCode,
    promoCodeError,
    getPromoCodeInfo,
    resetPromoCode,
  } = store

  useEffect(() => {
    if (showPromoInput && promoInputRef.current) {
      promoInputRef.current.focus()
    }
  }, [showPromoInput])

  return (
    <div className="w-full flex flex-col items-end justify-between ml-auto">
      {/* Total */}
      <div className="w-full flex flex-col items-end gap-2 my-10">
        <div className="w-full flex items-baseline justify-between gap-4">
          <Typography
            variant="body1_accent"
            className="my-0"
          >
            {texts?.total || "Estimated Total"}:
          </Typography>

          <Typography variant="h3">
            {getCartTotalValue()}
          </Typography>
        </div>

        {/* Discount info when promo code is applied */}
        {getPromoCodeInfo() && store.promoCode && (
          <Typography 
            variant="txt_accent" 
            className="text-success"
          >
            {t(texts?.discount, {
              discount: getPromoCodeInfo(),
            })}
          </Typography>
        )}
      </div>

      {/* Promo Code Group*/}
      <div className="w-full flex flex-col mb-0">
        {!showPromoInput ? (
          <div className="h-10 md:h-11 lg:h-12 flex items-start justify-center">
            <button
              className="text-primary text-left underline hover:opacity-70 transition-opacity"
              onClick={() => setShowPromoInput(true)}
            >
              {texts?.have_promocode || "Have a promocode?"}
            </button>
          </div>
        ) : (
          <div className="flex flex-row items-center justify-between gap-4">
            <Input
              ref={promoInputRef}
              variant="snap_compact"
              className="w-full"
              // label={`${texts?.promo_code}`}
              showClearButton
              placeholder={texts?.promo_code_placeholder || "Enter a promo code"}
              value={promoCode}
              onClear={resetPromoCode}
              onChange={(e) => {
                setPromoCodeError(null)
                setPromoCode(e.target.value.toUpperCase())
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  applyPromoCode()
                }
              }}
            />

            <Button
              variant="secondary"
              className="min-w-[100px] md:min-w-[120px]"
              onClick={applyPromoCode}
            >
              {texts?.promo_code_apply || "Apply"}
            </Button>
          </div>
        )}

        {/* Promo Code Error message */}
        {promoCodeError && (
          <Typography variant="txt_accent" className="text-error">
            {texts?.[promoCodeError] || promoCodeError}
          </Typography>
        )}
      </div>

      <Button
        variant="primary"
        className="w-full mt-4 !h-auto p-4"
        //TODO: Here would would plugin in some sales offers
        //TODO: Before the final checkout
        onClick={async () => await beginCheckout()}
      >
        {texts?.checkout}
        <ChevronRightIcon className="w-5 h-5 ml-3" />
      </Button>
    </div>
  )
}